/**
 * Application route constants
 * Single source of truth for all routes
 */

export const ROUTES = {
  HOME: '/',
  
  // Auth
  AUTH: '/auth',
  // Email auth routes
  SIGNIN: '/auth/signin',
  SIGNUP: '/auth/signup',
  SIGNUP_VERIFY: '/auth/signup/verify',
  SIGNUP_COMPLETE: '/auth/signup/complete',
  FORGOT_PASSWORD: '/auth/forgot',
  FORGOT_VERIFY: '/auth/forgot/verify',
  FORGOT_RESET: '/auth/forgot/reset',

  // Meetings
  MEETINGS_CREATE: '/meetings/create',
  MEETINGS_JOIN: '/meetings/join',

  // Schedule
  SCHEDULE: '/schedule',
  SCHEDULE_CREATE: '/schedule/create',

  // Recordings
  RECORDINGS: '/recordings',
  RECORDING_DETAILS: (recordingId: string) => `/recordings/${recordingId}`,
  // Public recording opened through a share link (no authentication required)
  RECORDING_SHARED: (shareToken: string) => `/recordings/shared/${shareToken}`,

  // Room
  ROOMS: (roomId: string) => `/rooms/${roomId}`,
} as const;
